import UserAccount from './UserAccount.mjs';
import { query, createElementFromHTML, showElement, hideElement } from '../utils.mjs';
import { PROPERTIES, HotelReservations } from './HotelReservations.mjs';
import WindCreekClient from './WindCreekClient.mjs';

UserAccount.windCreekClient = new WindCreekClient();

let reservationsPage = query('[data-my-reservations-page]');
let reservationsContainer = reservationsPage.querySelector('[data-my-reservations-container]');
let currentHotelContainer = reservationsPage.querySelector('[data-current-reservations] [data-hotel-reservations-list]');
let pastHotelContainer = reservationsPage.querySelector('[data-past-reservations] [data-hotel-reservations-list]');
let currentSpaContainer = reservationsPage.querySelector('[data-current-reservations] [data-spa-reservations-list]');
let pastSpaContainer = reservationsPage.querySelector('[data-past-reservations] [data-spa-reservations-list]');

// Generate the HTML for a single reservation card
function createHotelReservationCard(reservation, status) {
  let date = HotelReservations.getDate(reservation);
  let formattedCheckInDate = date.checkIn.getUTCMonth() + 1 + '/' + date.checkIn.getUTCDate() + '/' + date.checkIn.getUTCFullYear();
  let formattedCheckOutDate = date.checkOut.getUTCMonth() + 1 + '/' + date.checkOut.getUTCDate() + '/' + date.checkOut.getUTCFullYear();
  let textColor = (status === 'current') ? 'primary' : 'dark-subtle';

  // The reschedule CTA is only shown for current reservations
  let rescheduleCTA = '';
  if (status === 'current') {
    rescheduleCTA = `
      <hr class="m-0">
      <span class="subhead-3 text-dark-subtle d-block mb-0 text-center">Need to reschedule?</span>
      <a href="tel:+18669463360" class="btn btn-link btn-icon mx-auto">
        <span class="material-icons fs-lg">phone</span>
        866-WIND-360
      </a>
    `;
  }

  return `
    <div class="col-md-6 col-lg-4">
      <div class="card mb-3 bg-light">
        <div class="card-body d-flex flex-column gap-3">
          <h5 class="h3 text-${textColor} mb-0 text-center">
            Wind Creek ${PROPERTIES[reservation.hotelCode]}
          </h5>
          <span class="d-block text-center small">Confirmation #: ${reservation.reservationId}</span>
          <div class="bg-white rounded text-dark-subtle px-3 py-2">
            <div class="d-flex justify-content-between align-items-center gap-2 gap-xl-4">
              <div class="d-flex flex-column gap-1">
                <span class="fw-normal fs-sm" for="check-in">Check-In</span>
                <span class="label-1">${formattedCheckInDate}</span>
                <!-- <span class="fw-medium fs-sm">{{ Check-In Time }}</span> -->
              </div>
              <span class="material-icons text-${textColor}">arrow_forward</span>
              <div class="d-flex flex-column gap-1">
                <span class="fw-normal fs-sm" for="check-in">Check-Out</span>
                <span class="label-1">${formattedCheckOutDate}</span>
                <!-- <span class="fw-medium fs-sm">{{ Check-Out Time }}</span>-->
              </div>
            </div>
          </div>

          <div class="d-flex flex-column gap-3">
            <div class="d-flex justify-content-between">
              <div>
                <!--
                <span class="d-block fw-medium text-dark-subtle">{{ Summary }}</span>
                {{ Tags }}
                <div class="mt-2 d-flex gap-3">
                  <span class="material-icons text-${textColor}">smoke_free</span>
                  <span class="material-icons text-${textColor}">accessibility_new</span>
                </div>
                -->
              </div>
            </div>

            <hr class="m-0">

            <span class="label-2">Room Information</span>
            <div class="d-flex justify-content-between">
              <span class="">${reservation.roomTypeDescription}</span>
              <span class="fw-medium text-${textColor}">${reservation.formattedTotal}</span>
            </div>

            ${rescheduleCTA}
          </div>

        </div>
      </div>
    </div>
  `;
}

// This function populates the reservation data on the page
function setupReservationsPage(reservations) {
  let reservationsGroupedByStatus = HotelReservations.groupByStatus(reservations);

  let currentReservationsHTML = '';
  if (reservationsGroupedByStatus.current.length > 0) {
    reservationsGroupedByStatus.current.forEach(reservation => {
      currentReservationsHTML += createHotelReservationCard(reservation, 'current');
    });
  } else {
    currentReservationsHTML = '<p>You have no current room reservations</p>';
  }

  let currentReservationsElement = createElementFromHTML(currentReservationsHTML, 'div', true);
  currentHotelContainer.append(currentReservationsElement);

  let pastReservationsHTML = '';
  if (reservationsGroupedByStatus.past.length > 0) {
    reservationsGroupedByStatus.past.forEach(reservation => {
      pastReservationsHTML += createHotelReservationCard(reservation, 'past');
    });
  } else {
    pastReservationsHTML = '<p>You have no past room reservations</p>';
  }

  let pastReservationsElement = createElementFromHTML(pastReservationsHTML, 'div', true);
  pastHotelContainer.append(pastReservationsElement);
}

if (reservationsPage) {
  if (UserAccount.isLoggedIn()) {
    // The user has an existing session. Call the API to retrieve the reservation data.
    UserAccount.getHotelReservations()
    .then(reservations => {
      setupReservationsPage(reservations);
      reservationsPage.classList.remove('loading-animation');
    })
    .catch(error => {
      showElement('[data-page-error-message]');
      hideElement('[data-hide-on-page-error]');
      reservationsPage.classList.remove('loading-animation');
      console.log('unable to load reservations');
      console.error(error);
      newrelic.noticeError(error);
    });
  } else {
    // User is not logged in. Redirect to home page and prompt for authentication.
    UserAccount.forceAuthentication();
  }
}
